<template>
  <div class="main-content ofh">
    <demo-Header :message="message"></demo-Header>
    <div class="wrapper">
      <div class="page-content">
        <router-view></router-view>
      </div>
    </div>
    <demo-footer></demo-footer>
  </div>
</template>
<script type="text/javascript">
import demoHeader from "./headerSection";
import demoFooter from "./footer";

export default {
  name: "center",
  components: {
    demoHeader,
    demoFooter,
  },
  data() {
    return {
      message: this.$route.name,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/mainContent/index.vue